'use client';

import { cn } from '@/lib/utils';
import type { TrendingData } from '../ui/type';
import { CardBadge, CardMeta } from './TrendingCardContent';
import type { TrendingCardVariant } from './types';
import { getCardBackground } from './utils';

interface TrendingCardProps {
  trend: TrendingData;
  variant: TrendingCardVariant;
  onClick: () => void;
}

export default function TrendingCard({ trend, variant, onClick }: TrendingCardProps) {
  const background = getCardBackground(trend, trend.type);
  const isImage = variant === 'image';

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group relative w-full h-full overflow-hidden rounded-lg border border-[#242424] text-left transition-opacity hover:opacity-90',
        'bg-[#050505]',
        isImage ? 'aspect-square min-h-70 row-span-2' : '',
      )}
    >
      {isImage && background && (
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${background})` }}
        />
      )}
      <div
        className={cn(
          'absolute inset-0',
          isImage ? 'bg-linear-to-t from-black form-[25%] to-black/10 to-90%' : 'bg-[#121212]',
        )}
      />
      <div className={cn('relative flex h-full flex-col p-3.75')}>
        <CardBadge kind={trend.type} />
        <h3
          className={cn(
            'font-semibold text-white group-hover:text-[#B7B9BC]',
            isImage
              ? 'mt-auto line-clamp-3 text-lg leading-5.5'
              : 'mt-1 line-clamp-2 text-base leading-5',
            isImage && ['crypto', 'portfolio', 'question'].includes(trend.type) ? 'mt-15' : '',
          )}
        >
          {trend.query || trend.title}
        </h3>
        <CardMeta trend={trend} kind={trend.type} variant={variant} />
      </div>
    </button>
  );
}
